import { Device, until } from '@helpers/media';
import { withMotion } from '@hoc/withMotion';
import useMedia from '@hooks/useMedia';
import CarouselProvider from '@stories/Components/Misc/Carousels/Carousel/CarouselProvider/CarouselProvider';
import Pagination from '@stories/Components/Misc/Carousels/Carousel/Pagination/Pagination';
import HeadingSummaryBlock from '@stories/Components/Misc/HeadingSummaryBlock/HeadingSummaryBlock';
import { MotionConfig } from 'framer-motion';
import * as React from 'react';
import S from './FullWidthCarousel.styles';
function FullWidthCarousel(props) {
    const paddingOffset = useMedia([until(Device.Desktop)], [16], 0);
    if (!props.items || props.items.length === 0) {
        return null;
    }
    return (React.createElement(S.Container, { translations: props.translations },
        React.createElement(HeadingSummaryBlock, { ...props, layout: "split" }),
        React.createElement(MotionConfig, { transition: { duration: 0.3, ease: 'easeOut' } },
            React.createElement(CarouselProvider, { count: props.items.length, paddingOffset: paddingOffset },
                React.createElement(S.CarouselWrapper, null,
                    React.createElement(S.Track, { trackMutations: true }, props.items.map((item, i) => (React.createElement(S.Item, { key: `fw-carousel-${item.id}-${i}`, "data-is-featured": item.featured }, props.renderItem(item, i)))))),
                React.createElement(Pagination, { translations: props.translations })))));
}
export default withMotion(FullWidthCarousel);
